export const AUTH_REQUEST = 'AUTH_REQUEST';
export const SIGNUP = 'SIGNUP';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const AUTH_FAILURE = 'AUTH_FAILURE';
export const GET_AUTHENTICATED_USER = 'GET_AUTHENTICATED_USER';
export const EDIT_PROFILE = 'EDIT_PROFILE';
export const EDIT_PROFILE_FAILURE = 'EDIT_PROFILE_FAILURE';
export const EDIT_PROFILE_CLEANUP = 'EDIT_PROFILE_CLEANUP';
export const CLEANUP = 'CLEANUP';
